export const formatItemSystems = (
  systems: string[],
  constructionType?: string,
  separator = ' / ',
) => {
  return constructionType ? [constructionType, ...systems].filter(Boolean).join(separator) : '';
};
